// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconBanksCardsPath = 'M8.632 13H4a1 1 0 0 1-1-1V8h11v.634h2V6h-3.14l1.815-2.234L8.685 0l-1.52 2H4.11a3.073 3.073 0 0 0-3.1 2.74 2.623 2.623 0 0 0-.01.28V12a3 3 0 0 0 3 3h4.632v-2Zm.5-10.307 2.533 1.6L10.283 6H6.6l2.532-3.307ZM3 4.91c.091-.538.565-.927 1.11-.91h1.507L4.068 6H4a.949.949 0 0 1-.71-.31.885.885 0 0 1-.29-.67v-.11ZM19 15a3.97 3.97 0 0 0-.16-1.062l.99-.572-1-1.732-.98.566A3.994 3.994 0 0 0 16 11.142V10h-2v1.142a3.994 3.994 0 0 0-1.85 1.058l-.98-.566-1 1.732.991.572a3.583 3.583 0 0 0 0 2.124l-.99.572 1 1.732.98-.566c.509.514 1.148.88 1.85 1.058V20h2v-1.142a3.994 3.994 0 0 0 1.85-1.058l.98.566 1-1.732-.992-.572A3.97 3.97 0 0 0 19 15Zm-4 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z';
var IconBanksCards = baseIcon('IconBanksCards', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconBanksCardsPath
});
export default IconBanksCards;
//# sourceMappingURL=index.js.map